import React from "react";
import { useTranslation } from "@helpers/translate";
import "./index.sass";

const statsFallback = {
  totalPnl: 0,
  averageDailyPnl: 0,
  averageMonthlyPnl: 0,
  profitableDays: 0,
  losingDays: 0,
  profitableMonths: 0,
  losingMonths: 0,
  bestDay: 0,
  bestMonth: 0,
};

const formatCurrency = (value) => {
  const number = Number(value || 0);

  if (number === 0) {
    return "$0";
  }

  const sign = number > 0 ? "+" : "-";

  const formattedValue = Math.abs(number).toLocaleString("en-US", {
    minimumFractionDigits: 0,
    maximumFractionDigits: 2,
  });

  return `${sign}$${formattedValue}`;
};

export const TradingPnlStatsCard = ({
  mode = "daily",
  stats,
  style,
  isEqualHeight = false,
}) => {
  const { __ } = useTranslation();

  const itemStyle = isEqualHeight ? { flex: "1 1 0" } : undefined;

  const currentStats = {
    ...statsFallback,
    ...(stats || {}),
  };

  const isDailyMode = mode === "daily";

  const averageLabel = isDailyMode
    ? __("trading_profile.average_daily_pnl")
    : __("trading_profile.average_monthly_pnl");

  const profitableLabel = isDailyMode
    ? __("trading_profile.profitable_days")
    : __("trading_profile.profitable_months");

  const losingLabel = isDailyMode
    ? __("trading_profile.losing_days")
    : __("trading_profile.losing_months");

  const bestLabel = isDailyMode
    ? __("trading_profile.best_day")
    : __("trading_profile.best_month");

  const averageValue = isDailyMode
    ? currentStats.averageDailyPnl
    : currentStats.averageMonthlyPnl;

  const profitableValue = isDailyMode
    ? currentStats.profitableDays
    : currentStats.profitableMonths;

  const losingValue = isDailyMode
    ? currentStats.losingDays
    : currentStats.losingMonths;

  const bestValue = isDailyMode ? currentStats.bestDay : currentStats.bestMonth;

  return (
    <div className="trading-pnl-stats-card" style={style}>
      <div className="trading-pnl-stats-card__item" style={itemStyle}>
        <div className="trading-pnl-stats-card__content">
          <span className="trading-pnl-stats-card__label">
            {__("trading_profile.total_pnl")}
          </span>

          <span className="trading-pnl-stats-card__value">
            {formatCurrency(currentStats.totalPnl)}
          </span>
        </div>
      </div>

      <div className="trading-pnl-stats-card__item" style={itemStyle}>
        <div className="trading-pnl-stats-card__content">
          <span className="trading-pnl-stats-card__label">{averageLabel}</span>

          <span className="trading-pnl-stats-card__value">
            {formatCurrency(averageValue)}
          </span>
        </div>
      </div>

      <div
        className="trading-pnl-stats-card__item trading-pnl-stats-card__item--double"
        style={itemStyle}
      >
        <div className="trading-pnl-stats-card__content trading-pnl-stats-card__content--double">
          <div className="trading-pnl-stats-card__column">
            <span className="trading-pnl-stats-card__label">
              {profitableLabel}
            </span>

            <span className="trading-pnl-stats-card__value">
              {profitableValue}
            </span>
          </div>

          <div className="trading-pnl-stats-card__column">
            <span className="trading-pnl-stats-card__label">{losingLabel}</span>

            <span className="trading-pnl-stats-card__value">{losingValue}</span>
          </div>
        </div>
      </div>

      <div className="trading-pnl-stats-card__item" style={itemStyle}>
        <div className="trading-pnl-stats-card__content">
          <span className="trading-pnl-stats-card__label">{bestLabel}</span>

          <span className="trading-pnl-stats-card__value">
            {formatCurrency(bestValue)}
          </span>
        </div>
      </div>
    </div>
  );
};

export default TradingPnlStatsCard;